import HttpService, { ApiUrl, baseUrl } from "../../constant/Api";

export const getFAQService = (
  params = {
    pageNumber: 0,
    pageSize: 20,
    sort: "ASC",
    targetWord: "",
  }
) => {
  return HttpService.get(baseUrl + ApiUrl.faq.faq_get, { params });
};
